import * as React from 'react';

type SlotProps = React.HTMLAttributes<HTMLElement> & React.RefAttributes<HTMLElement> & {
    children?: React.ReactNode,
};

const Slot = ({
    children,
    ...props
}: SlotProps) => (
    <>
        {React.Children.toArray(children)
            .filter((child): child is React.ReactElement => React.isValidElement(child))
            .map(child => React.cloneElement(child, {
                ...child.props,
                ...props,
            }))}
    </>
);

export default Slot;
